import {combineReducers, configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import {persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER} from 'redux-persist';
import storage from 'redux-persist/lib/storage';  // defaults to localStorage for web

import {microservicesReducer} from './features/microservices.slice';
import {typesReducer} from './features/types.slice';
import {caseReducer} from './features/case.slice';

const persistConfig = {
  key: 'root',
  storage
};

const reducer = combineReducers({
  microservices: microservicesReducer,
  types: typesReducer,
  case: caseReducer
});

const store = configureStore({
  reducer: persistReducer(persistConfig, reducer),
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});
const persistor = persistStore(store);

export {store, persistor};